import React from "react";
import InfoParagraph from "./index";

export const ACCOUNTING_NOTE_VISIBLE = 'visible';
export const ACCOUNTING_NOTE_PROCESSED = 'processed';
export const ACCOUNTING_NOTE_WAITING = 'waiting';

/**
 * The one "Accounting" note shown on records another department hands to Accounting
 * (work orders, inspections, recruiting expenses), so all of them read and look the same:
 *
 * - ACCOUNTING_NOTE_VISIBLE   (green) Accounting can process it now.
 * - ACCOUNTING_NOTE_PROCESSED (green) Accounting has already processed it.
 * - ACCOUNTING_NOTE_WAITING   (grey)  Not visible to Accounting yet; the message says when it will be.
 *
 * Wording convention for the message:
 *   visible:   "This <record> is visible to Accounting for processing (<pay screen>)."
 *   processed: "Accounting has already processed this <record>." (+ what that locks, if anything)
 *   waiting:   "Accounting will see this <record> once <condition>."
 */
export default function AccountingVisibilityNote({state, message, className}) {
    if (!message) {
        return null;
    }

    return (
        <InfoParagraph
            type={state === ACCOUNTING_NOTE_WAITING ? "note" : "success"}
            className={className}
            message={message}
        />
    );
}
